import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './LoginPage.css';

/**
 * Login-sida med val mellan Steam (Sprint 2 av Fluxer-migrationen) och
 * Discord OAuth (legacy).
 *
 * Närvarar inte automatiskt på /login — UserMenu visar Steam-knappen
 * inline för bekvämlighet. /login är till för dedikerad delning
 * (t.ex. invite-länkar pekar dit).
 *
 * Om användaren redan är inloggad redirectas de till framsidan, eller
 * /pending om deras access_status inte är 'active'.
 */
export default function LoginPage() {
  const { t } = useTranslation();
  const { isLoggedIn, isPending, login, loginSteam } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoggedIn) return;
    navigate(isPending ? '/pending' : '/', { replace: true });
  }, [isLoggedIn, isPending, navigate]);

  return (
    <div className="login-page">
      <div className="login-card">
        <h1 className="login-title">{t('auth.login')}</h1>
        <p className="login-subtitle">
          {t('auth.loginIntro')}</p>
        <div className="login-button-group">
          <button
            className="login-button login-button-steam"
            onClick={loginSteam}
            type="button"
          >
            <span className="login-button-icon" aria-hidden>🎮</span>
            {t('auth.loginSteam')}
          </button>
          <div className="login-divider">{t('auth.or')}</div>
          <button
            className="login-button login-button-discord"
            onClick={login}
            type="button"
          >
            <span className="login-button-icon" aria-hidden>💬</span>
            {t('auth.loginDiscord')}
          </button>
        </div>
        <div className="login-info">
          {t('auth.firstTimeHint')}
        </div>
      </div>
    </div>
  );
}
